import React, { useEffect, useState } from 'react';
import { Table, Spin, Switch, Modal, Typography, message } from 'antd';
import get from 'lodash/get';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { userMangement } from '../../redux/actions/authActions';
import { generatePaginationObj } from '../../utilities/helpers';
import MarketingAgencyInfo from '../../components/superAdminUser/marketingAgencyInfo';
import { MARKETING_SUBSCRIPTION_SUCCESS } from '../../constants/messages';

const { Text } = Typography;
const { confirm } = Modal;

function SuperAdminMarketingAgency() {
  const [loading, setLoading] = useState(false);

  const [agencyDetailModal, setBrandsDetailModal] = useState({
    visible: false,
    data: null,
  });

  const [marketingAgencies, setMarketingAgencies] = useState({
    data: [],
    pagination: {
      offset: 0,
      limit: 10,
      total: 0,
      current: 1,
    },
  });

  const toggleAgencyDetailModal = (data = null) => {
    setBrandsDetailModal({
      visible: !get(agencyDetailModal, 'visible'),
      data,
    });
  };

  const dispatch = useDispatch();

  const getMarketingList = (page = 1) => {
    setLoading(true);
    const pageObj = generatePaginationObj(
      page,
      get(marketingAgencies, 'pagination.limit')
    );
    dispatch(
      userMangement('list.marketing_companies', {
        ...pageObj,
      })
    )
      .then((result) => {
        setLoading(false);
        setMarketingAgencies({
          data: get(result, 'data', []),
          pagination: {
            ...pageObj,
            total: get(result, 'total'),
            current: page,
          },
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getAgencyDetails = (id) => {
    setLoading(true);
    dispatch(
      userMangement('get.marketing_company', {
        id,
      })
    )
      .then((result) => {
        toggleAgencyDetailModal(get(result, 'data'));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getMarketingList();
  }, []);

  const changeSubscription = (id, status) => {
    setLoading(true);
    dispatch(
      userMangement('update.marketing_company', {
        id,
        is_active: status,
      })
    )
      .then(() => {
        message.success(MARKETING_SUBSCRIPTION_SUCCESS);
        getMarketingList(get(marketingAgencies, 'pagination.current'));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onChangeSubscriptionStatus = (id, status) => {
    confirm({
      title: 'Aur you Sure?',
      icon: <ExclamationCircleFilled />,
      content: 'You want change Subscription status of this marketing agency!',
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        changeSubscription(id, status);
      },
      onCancel() {},
    });
  };

  return (
    <div className="team-detail-container">
      <Spin spinning={loading}>
        <Table
          rowKey="id"
          columns={[
            {
              title: 'Name',
              key: 'name',
              dataIndex: 'name',
              render: (text, record) => (
                <Text
                  className="text-theme-color"
                  onClick={() => {
                    getAgencyDetails(get(record, 'id'));
                  }}
                >
                  {text}
                </Text>
              ),
            },
            {
              title: 'Date',
              key: 'created_at',
              dataIndex: 'created_at',
              render: (createdAt) =>
                moment(createdAt).format('DD/MM/YYYY (HH:mm A)'),
            },
            {
              title: 'Subscription',
              key: 'is_active',
              dataIndex: 'is_active',
              render: (active, record) => (
                <>
                  <Switch
                    checked={active}
                    onChange={(status) =>
                      onChangeSubscriptionStatus(get(record, 'id'), status)
                    }
                  />
                </>
              ),
            },
          ]}
          dataSource={get(marketingAgencies, 'data')}
          pagination={{
            showSizeChanger: false,
            position: ['bottomCenter'],
            hideOnSinglePage: true,
            pageSize: get(marketingAgencies, 'pagination.limit'),
            total: get(marketingAgencies, 'pagination.total'),
            current: get(marketingAgencies, 'pagination.current'),
          }}
          onChange={(paginationObj) => {
            getMarketingList(get(paginationObj, 'current'));
          }}
        />

        <Modal
          width="45%"
          className="common-modal"
          destroyOnClose
          open={get(agencyDetailModal, 'visible')}
          onOk={toggleAgencyDetailModal}
          onCancel={toggleAgencyDetailModal}
          footer={null}
          maskClosable={false}
        >
          <MarketingAgencyInfo
            agency={get(agencyDetailModal, 'data')}
            onClose={toggleAgencyDetailModal}
          />
        </Modal>
      </Spin>
    </div>
  );
}

export default SuperAdminMarketingAgency;
